import { render, staticRenderFns } from "./EcommerceDetail.vue?vue&type=template&id=7292688a&scoped=true"
import script from "./EcommerceDetail.vue?vue&type=script&lang=js"
export * from "./EcommerceDetail.vue?vue&type=script&lang=js"
import style0 from "./EcommerceDetail.vue?vue&type=style&index=0&id=7292688a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7292688a",
  null
  
)

export default component.exports